import FileDetail from './FileDetail';
import './FileDetail.scss';

export default FileDetail;
